import { Reveal, SectionHead } from "./shared";

const STEPS = [
  {
    num: "01",
    title: "Site Audit & Scope",
    body: "We walk the property with you, measure what matters, and flag the stuff others miss — drainage, load paths, permit needs.",
  },
  {
    num: "02",
    title: "Written Estimate",
    body: "A line-itemed, fixed-scope estimate within 24 hours. Ballpark games end here; you'll know exactly what's in and what's out.",
  },
  {
    num: "03",
    title: "Precision Build",
    body: "The owner is on site daily. Materials staged clean, work areas locked down, and progress photos in your pocket every week.",
  },
  {
    num: "04",
    title: "Inspect & Handover",
    body: "Final walkthrough together, punch list closed on the spot, permits closed out, and the site swept like we were never there.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-20 md:py-32 bg-ink-card/40">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-16">
        <SectionHead
          eyebrow="How it works"
          title="Four steps. No surprises."
          sub="From first walkthrough to final sweep — here's exactly how a TCB project runs."
        />

        <div className="relative mt-16">
          <div className="hidden lg:block absolute top-0 left-0 right-0 h-[2px] bg-line" aria-hidden="true" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.num} delay={i * 0.1} className="relative">
                <div className="hidden lg:block absolute -top-[5px] left-0 w-3 h-3 bg-safety rotate-45" aria-hidden="true" />
                <span className="font-display text-6xl text-outline leading-none block">{s.num}</span>
                <h3 className="font-cond font-bold uppercase text-2xl tracking-wide text-bone mt-6">{s.title}</h3>
                <p className="text-steel text-sm leading-relaxed mt-3">{s.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
